import { render, staticRenderFns } from "./CreateOrdersModal.vue?vue&type=template&id=08047cca&scoped=true&"
import script from "./CreateOrdersModal.vue?vue&type=script&lang=js&"
export * from "./CreateOrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrdersModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CreateOrdersModal.vue?vue&type=style&index=1&id=08047cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08047cca",
  null
  
)

export default component.exports